/*global _ */
import {RE} from '../config'

export const getREProducts = () => {
  const products = RE.products || {}
  if (!products.typed) {
    products.types = _.mapValues(products.types || {}, (i, type) => {
      i = _.map(i, p => {
        p.type = p.type || type
        return p
      })
      return i
    })
    products.typed = true
  }
  return products
}

export const filterByLocation = (products, location, isStrict) => {
  return _.filter(products, product => {
    if (!product) {
      return false
    }

    const productLocation = product.location_id
    const supportedLocation = product.supported_locations || []
    const noLocation = !productLocation && _.isEmpty(supportedLocation)
    return (!isStrict && noLocation) ||
      supportedLocation.includes(location) ||
      productLocation === location
  })
}

export const getProducts = (flatten = true) => {
  const products = _.get(getREProducts(), 'types')
  if (flatten) {
    return _.flatMap(products)
  }
  return products
}
export const getProductsByType = (type) => {
  if (_.isEmpty(type)) {
    return getProducts(true)
  }
  return _.flatMap(_.pick(_.get(getREProducts(), 'types'), _.castArray(type)))
}

export const getProductById = (id, getCopy = true) => {
  const products = getProducts()
  const product =  _.find(products, p => p.id == id)
  if (getCopy) {
    return _.cloneDeep(product)
  }
  return product
}

export default {filterByLocation, getProducts, getProductsByType, getProductById, getREProducts}
